import {Component, Input, OnInit} from '@angular/core';
import {ListItem} from "../../../objects/listItem";
import {UserPermissions} from "../../../objects/permissions";
import {DialogCanvasComponent} from "../../dialog-canvas/dialog-canvas.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {AppComponent} from "../../../app.component";
import {MobileContainerComponent} from "../mobile-container/mobile-container.component";
import {AppEvent} from "../../../objects/appEvent";
import {SharedDataService} from "../../../services/shared-data.service";
import {SubscriptionLike} from "rxjs";

@Component({
  selector: 'app-event-listing-item',
  templateUrl: './event-listing-item.component.html',
  styleUrls: ['../mobile-container/mobile-container.component.scss']
})
export class EventListingItemComponent implements OnInit {
  private _listItem: ListItem;
  private eventPayload: object;
  @Input()
  set listItem(value: ListItem) {
    this._listItem = value;
    this.eventPayload = JSON.parse(this.listItem['itemFullData']['payload']);
    switch (this.eventPayload['type']) {
      // case 'squashtime_game_finish':
      // case 'game_finish':
      // case 'tournament_game_finish':
      case 'game_proposal':
      case 'tournament_game_proposal':
      case 'trainer_booking_add':
      case 'trainer_booking_cancel':
        this.state = 'split';
        break;
      default:
        this.state = 'default';
    }
    if(this.state === 'split') {
      this.profileLeft = this.eventPayload['profiles'][0];
      this.profileRight = this.eventPayload['profiles'][1];
    } else {
      this.profileLeft = this.listItem['itemFullData']['profileData'];
    }
  }
  get listItem(): ListItem {
    return this._listItem
  }
  @Input() activeItemCounter: number; //used in right click menu

  state = 'default'
  profileLeft = {}
  profileRight = {}

  private commonDialogConf = {
    autoFocus: false,
    panelClass: 'common-dialog'
  }
  private sharedEventSubscription: SubscriptionLike;

  constructor(public dialog: MatDialog,
              public mobileContainer: MobileContainerComponent,
              public application: AppComponent,
              private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.sharedEventSubscription = this.sharedDataService.globalEventObservable$.subscribe(
      appEvent => {
        if (appEvent.type === AppEvent.EVENT_UPDATED) {
          if(this.listItem['itemFullData']['id'] == appEvent.data['item']['itemFullData']['id']) {
            this.listItem = appEvent.data['item'];
          }
        }
      });
  }
  ngOnDestroy() {
    this.sharedEventSubscription.unsubscribe();
  }

  setIsSelected(state): boolean {
    this.listItem.isSelected = state;
    return true;
  }

  public itemOpen() {
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      ...this.commonDialogConf,
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '90%' : '65%',
      data: {
        application: this.application,
        state: 'event-open',
        payload: {item: this.listItem},
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
  }

}
